module.exports = __webpack_public_path__ + "img/complete_btn.3f70eab1.png";